<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="ts-space-y-2">
        <div class="row">
          <div class="col-md-12">
            <label class="required ts-text-xs">{{ $t('exchangeRate.date') }}</label>
            <a-date-picker
              v-model="model.dates"
              class="ts-w-full"
              show-time placeholder="Select Time"
              format="DD-MM-YYYY HH:mm:ss"
              valueFormat="DD-MM-YYYY HH:mm:ss"
            ></a-date-picker>
            <div
              class="validate ts-text-xs"
              v-if="errors.has('dates')"
            >{{ errors.first('dates') }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-6">
                <label class="required ts-text-xs">{{ $t('exchangeRate.fromCurrency') }}</label>
                <a-select
                  v-model.number="model.currency_id_from"
                  :options="currencies"
                  showSearch
                  :filterOption="(input, option) => option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0" 
                  class="ts-w-full"></a-select>
                <div
                  class="validate ts-text-xs"
                  v-if="errors.has('currency_id_from')"
                >{{ errors.first('currency_id_from') }}</div>
              </div>
              <div class="col-md-6">
                <label class="required ts-text-xs">{{ $t('exchangeRate.toCurrency') }}</label>
                <a-select
                  v-model.number="model.currency_id_to"
                  :options="currencies"
                  showSearch
                  :filterOption="(input, option) => option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0"   
                  class="ts-w-full"></a-select>
                <div
                  class="validate ts-text-xs"
                  v-if="errors.has('currency_id_to')"
                >{{ errors.first('currency_id_to') }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label class="required ts-text-xs">{{ $t('exchangeRate.fxRate') }}</label>
            <input
              v-model.number="model.fx_rate"
              type="number"
              step="any"
              class="form-control"
              :class="{ 'is-invalid': errors.has('fx_rate') }"
            />
            <div
              class="validate ts-text-xs"
              v-if="errors.has('fx_rate')"
            >{{ errors.first('fx_rate') }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 ts-mt-3 text-right">
            <ts-button class="mr-2" @click.prevent="() => $emit('cancel')">
              {{
              $t('cancel')
              }}
            </ts-button>
            <ts-button color="primary" @click.prevent="onSave" :waiting="waiting">{{ $t('save') }}</ts-button>
          </div>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import moment from 'moment'
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'

export default {
  name: 'exchangeRateForm',
  data() {
    return {
      errors: new Errors(),
      waiting: false,
      loading: false,
      waiting_new: false,
      currencies: [],
      model: {
        dates: moment().format('DD-MM-YYYY HH:mm:ss'),
        currency_id_from: '',
        currency_id_to: '',
        fx_rate: ''
      }
    }
  },
  created(){
    this.fetchCurrency()
  },
  methods: {
    fetchCurrency(){
      this.loading = true
      this.$store
        .dispatch('exchangeRate/currencyRate/getCurrency')
        .then(response => {
          this.currencies = response.data.map(el => ({
            value: el.currency_id,
            label: el.currency_code
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onSave() {
      this.waiting = true
      this.errors = new Errors()
      this.$store
        .dispatch('exchangeRate/currencyRate/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    }
  }
}
</script>
